import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Source } from "trader.ts/types/source";
import { dyn, scheduleForCleanup } from "trader.ts/ui";
import { textbox } from "trader.ts/ui.common";
import { checkAllCasesHandled, tryExtractErrorMessage } from "trader.ts/utils";
import * as FA from "../../../styles/fontawesome.css.classes";
import * as style from "../../../styles/style.css.classes";
import * as routes from "../../routes";
import { emailIsValid } from "../../lib/emailisvalid";

export function render(opts: {
  tag: "passwordless" | "with_password";
  ps: {
    redirecturl: string | undefined;
    redirectdescription: string | undefined;
  };
}): HTMLElement | HTMLElement[] {
  if (opts.tag === "passwordless") {
    return renderPasswordlessForm(opts.ps);
  } else if (opts.tag === "with_password") {
    return renderWithPasswordForm(opts.ps);
  } else {
    return checkAllCasesHandled(opts.tag);
  }
}

function renderWithPasswordForm(ps: {
  redirecturl: string | undefined;
  redirectdescription: string | undefined;
}): HTMLElement | HTMLElement[] {
  const emailS = new Source("");
  const passwordS = new Source("");
  const errorS: Source<null | string> = new Source(null);

  scheduleForCleanup(emailS.observe(() => errorS.set(null)));
  scheduleForCleanup(passwordS.observe(() => errorS.set(null)));

  function doWithPasswordLogin(ev: Event) {
    ev.preventDefault();
    errorS.set(null);
    rpc(routes.tryWithPasswordLoginSpec, ps, {
      email: emailS.get(),
      password: passwordS.get(),
    })
      .then((res) => {
        if (res.tag === "error") {
          errorS.set(res.error);
        } else {
          document.location = res.url;
        }
      })
      .catch((err) => errorS.set(tryExtractErrorMessage(err)));
  }

  return (
    <div>
      <div className={style.card}>
        <form>
          <div>
            <label>
              <div> {"emailadres"} </div>
              <div className={style.input_with_icon}>
                <i className={FA.icon_envelope_solid}></i>
                {textbox({
                  type: "email",
                  style: "background-color: white",
                  source: emailS,
                })}
              </div>
            </label>
          </div>

          <div>
            <div>
              <label>
                <div> {"wachtwoord"} </div>
                <div className={style.input_with_icon}>
                  <i className={FA.icon_question_solid}></i>
                  {textbox({
                    type: "password",
                    style: "background-color: white",
                    source: passwordS,
                  })}
                </div>
              </label>
            </div>
          </div>

          {dyn(errorS, (error) =>
            error !== null ? (
              <label className={style.session_error}>{error}</label>
            ) : (
              <span></span>
            ),
          )}

          <div style="text-align: right">
            <input
              type="submit"
              onclick={doWithPasswordLogin}
              className={style.button_accent}
              value="OK"
            />
            <a
              href={routes.login_with_password_helpRoute.link(ps)}
              style="margin-top: 8px"
            >
              {"Hoe maak ik een wachtwoord aan?"}
            </a>
          </div>
        </form>
      </div>
      <div className={style.session_link_under_card_container}>
        <a href={routes.loginPasswordlessRoute.link(ps)}>
          {"Ik wil inloggen met alleen mijn emailadres"}
        </a>
      </div>
    </div>
  );
}

function renderPasswordlessForm(ps: {
  redirecturl: string | undefined;
  redirectdescription: string | undefined;
}): HTMLElement | HTMLElement[] {
  const emailS = new Source("");
  const errorS: Source<null | string> = new Source(null);
  const loginState: Source<"initial" | "email_sent"> = new Source("initial");

  scheduleForCleanup(emailS.observe(() => errorS.set(null)));

  function doPasswordlessLogin(ev: Event) {
    ev.preventDefault();

    const email = emailS.get();
    if (emailIsValid(email) === false) {
      errorS.set("Dit emailadres is ongeldig");
    } else {
      rpc(routes.tryPasswordlessLoginSpec, ps, { email })
        .then((res) =>
          res.tag === "error"
            ? errorS.set(res.error)
            : loginState.set("email_sent"),
        )
        .catch((err) => errorS.set(tryExtractErrorMessage(err)));
    }
  }

  return (
    <div>
      <div className={style.card}>
        {dyn(loginState, (loginState) => {
          if (loginState === "initial") {
            return (
              <form>
                <div>
                  <label>
                    <div>{"emailadres"}</div>
                    <div className={style.input_with_icon}>
                      <i className={FA.icon_envelope_solid}></i>
                      {textbox({
                        source: emailS,
                        type: "email",
                        id: "email",
                        style: "background-color: white",
                      })}
                    </div>
                  </label>
                </div>

                {dyn(errorS, (error) =>
                  error !== null ? (
                    <label className={style.session_error}>{error}</label>
                  ) : (
                    <span></span>
                  ),
                )}

                <div style="text-align: right">
                  <input
                    type="submit"
                    onclick={doPasswordlessLogin}
                    className={style.button_accent}
                    value="OK"
                  />
                  <br />
                  <a href={routes.login_passwordless_helpRoute.link(ps)}>
                    {"Hoe werkt dit?"}
                  </a>
                </div>
              </form>
            );
          } else if (loginState === "email_sent") {
            return (
              <div>
                <h1>
                  {"Gelukt! Volg de link die we naar je mailbox stuurden om in te loggen."}
                </h1>
              </div>
            );
          } else {
            return checkAllCasesHandled(loginState);
          }
        })}
      </div>
      <div className={style.session_link_under_card_container}>
        <a href={routes.loginWithPasswordRoute.link(ps)}>
          {"Ik wil inloggen met mijn wachtwoord"}
        </a>
      </div>
    </div>
  );
}
